<template>
  <div class="loader linear" :class="type">
    <div class="el">
      <div v-if="type === 'progress'" class="progress" ref="percentage"></div>
    </div>
    <div v-if="text" class="text">
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LinearLoader",
  props: {
    text: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "infinite"
    },
    percentage: {
      type: Number,
      default: 0
    }
  },
  watch: {
    percentage(newPercentage) {
      this.setPercentage(newPercentage);
    }
  },
  methods: {
    setPercentage(percentage) {
      this.$refs.percentage.style.width = `${percentage}%`;
    }
  }
};
</script>
